import { CURSOR_TIP_OFFSET } from "./denker-cursor-controller-types";

const DOCK_AVATAR_VISUAL_BIAS_X = 12;

type AnchorOptions = {
  dockAvatar?: boolean;
};

function renderedCursorTipOffset(): { x: number; y: number } {
  if (typeof document === "undefined") return CURSOR_TIP_OFFSET;
  const root = document.querySelector<HTMLElement>(
    '[data-testid="denker-onboarding-cursor"]',
  );
  const path = document.querySelector<SVGGeometryElement>(
    '[data-testid="denker-onboarding-cursor-tip"]',
  );
  if (!root || !path || !path.getScreenCTM || !path.getPointAtLength) {
    return CURSOR_TIP_OFFSET;
  }

  try {
    const point = path.getPointAtLength(0);
    const matrix = path.getScreenCTM();
    if (!matrix) return CURSOR_TIP_OFFSET;
    const screenPoint = new DOMPoint(point.x, point.y).matrixTransform(matrix);
    const rootRect = root.getBoundingClientRect();
    return {
      x: screenPoint.x - rootRect.left,
      y: screenPoint.y - rootRect.top,
    };
  } catch {
    return CURSOR_TIP_OFFSET;
  }
}

export function rectCenterAnchor(
  rect: DOMRect,
  options: AnchorOptions = {},
): { x: number; y: number } {
  const biasX = options.dockAvatar ? DOCK_AVATAR_VISUAL_BIAS_X : 0;
  const tipOffset = options.dockAvatar
    ? renderedCursorTipOffset()
    : CURSOR_TIP_OFFSET;
  return {
    x: rect.left + rect.width / 2 + biasX - tipOffset.x,
    y: rect.top + rect.height / 2 - tipOffset.y,
  };
}
